module.exports = __webpack_public_path__ + "nab.woff?2c5cedd983d40f4179ede386b4d31f2a";


//////////////////
// WEBPACK FOOTER
// ./~/@nsftx/nfont/css/fonts/nab.woff
// module id = 319
// module chunks = 0